//Accordion
function accordion() {
  var accordion = $(".accordion"),
    opener = $("h3"),
    slider = $(".slide");

  // if($(opener).parent().hasClass('active')){
  //   $('.active').find(slider).show();
  // }

  $(accordion)
    .find(opener)
    .click(function (e) {
      var $this = $(this);
      if ($this.parent().hasClass("active")) {
        $this.parent().removeClass("active");
        $this.next(slider).slideUp();
      } else {
        // $this.parents(accordion).children(opener).removeClass('active');
        // $this.parents('.accordion').find('.slide').slideUp();
        $(opener).parent().removeClass("active");
        $this.parents(accordion).find(slider).slideUp();
        $this.parent().addClass("active");
        $this.next(slider).slideDown();
      }
      e.preventDefault();
    });
}

jQuery(document).ready(function ($) {
  accordion();

  if ($(".testimonials-slider").length > 0) {
    // console.log("testimonials-slider found");
    $(".testimonials-slider").slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
});